import { useAccount, useMsal } from "@azure/msal-react";
import {
    Container
} from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';
import { DataGrid, GridCellParams, GridColDef, GridRowParams, GridSortModel, GridValueGetterParams, deDE, LocalizationV4 } from "@material-ui/data-grid";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { messstelle, schaltfeld } from "../../../utils/apiTypes";
import {
    getMessstellen, getSchaltfelder, messstelleDummy, selectListLoading, selectMessstellen, selectSchaltfelder,
    selectSorting,
    setSorting,
    updateAktuelleMessstelle
} from "./messstellenSlice";
import { useStyles } from "./messstellenStyles";
import { alphaNumSort } from "../../../utils/utils";
import { useParams } from 'react-router';

export default function MessstellenGrid(): ReactElement {

    const dispatch = useAppDispatch();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const { id } = useParams<{id: string | undefined}>();


    const dataGridCols2: GridColDef[] = [
        {
            field: 'status', headerName: ' ', flex: 0.2, renderCell: function status(params: GridCellParams) {
                return (<React.Fragment>
                    {params.getValue(params.id, 'zugeordnet') ?
                        <Tooltip title="Aktivem Messpunkt zugeordnet">
                            <FiberManualRecordIcon color="secondary" />
                        </Tooltip>
                        : (params.getValue(params.id, 'jemalsZugeordnet') ?
                            <Tooltip title="Aktivem Messpunkt zugeordnet gewesen">
                                <FiberManualRecordOutlinedIcon color="secondary" />
                            </Tooltip>
                            : "")}</React.Fragment>)
            },
            sortComparator: (v1, v2, param1, param2) => {
                const p1 = param1.api.getCellValue(param1.id, 'zugeordnet') ? 2 : param1.api.getCellValue(param1.id, 'jemalsZugeordnet') ? 1 : 0;
                const p2 = param1.api.getCellValue(param2.id, 'zugeordnet') ? 2 : param1.api.getCellValue(param2.id, 'jemalsZugeordnet') ? 1 : 0;
                return p2 - p1;
            }, filterable: false
        },
        { field: 'name', headerName: 'Messstelle', flex: 1, sortComparator: alphaNumSort },
        { field: 'umspannwerk', headerName: 'Umspannwerk', flex: 1 },
        { field: 'schaltfeld', headerName: 'Feldname', flex: 1, sortComparator: alphaNumSort },
        {
            field: 'schaltfeldnummer', headerName: 'Feldnummer', flex: 1,
            valueGetter: (params: GridValueGetterParams) => {
                return schaltfeldSelectList.length == 0 ? "Wird geladen..." : schaltfeldSelectList.find(x => x.umspannwerk == params.getValue(params.id, 'umspannwerk') && x.name == params.getValue(params.id, 'schaltfeld'))?.nummer;
            },
            sortComparator: (v1, v2, param1, param2) => {
                const p1 = schaltfeldSelectList.find(x => x.umspannwerk == param1.api.getCellValue(param1.id, 'umspannwerk') && x.name == param1.api.getCellValue(param1.id, 'schaltfeld'))?.nummer;
                const p2 = schaltfeldSelectList.find(x => x.umspannwerk == param2.api.getCellValue(param2.id, 'umspannwerk') && param2.api.getCellValue(param2.id, 'schaltfeld'))?.nummer;
                const c1 = p1 ? p1 : "";
                const c2 = p2 ? p2 : "";
                return c1.localeCompare(c2);
            }
        },
        { field: 'spannungsebene', headerName: 'Spannungsebene', flex: 1, sortComparator: alphaNumSort },
        { field: 'stromwandler', headerName: 'Stromwandler', flex: 1, sortComparator: alphaNumSort },
        { field: 'spannungswandler', headerName: 'Spannungswandler', flex: 1, sortComparator: alphaNumSort }
    ]
    useEffect(() => {
        dispatch(getMessstellen(id));
        dispatch(getSchaltfelder());
    }, [account, instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };
    const
        data: messstelle[] = useAppSelector(selectMessstellen),
        schaltfeldSelectList: schaltfeld[] = useAppSelector(selectSchaltfelder),
        listLoading: boolean = useAppSelector(selectListLoading),
        sorting: GridSortModel = useAppSelector(selectSorting);

    return (
        <Container maxWidth={false} className={classes.root} >
            <div style={{ height: "50vh" }}>

                <DataGrid
                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                    disableColumnMenu={false}
                    disableColumnSelector={true}
                    columns={dataGridCols2}
                    rows={data}
                    getRowId={(row) => row.name}
                    sortModel={sorting}
                    onSortModelChange={(model) => setSorting(model.sortModel)}
                    onRowClick={(param: GridRowParams) => {
                        let mt = messstelleDummy;
                        const temp = data.find(mst => mst.name == (param.row.name))
                        if (temp)
                            mt = temp;
                        dispatch(updateAktuelleMessstelle(mt));
                    }
                    }
                    loading={listLoading}
                    className={classes.zeroPadding}
                />
            </div>
        </Container>
    );
}
